module.exports = __webpack_public_path__ + "img/Steor-Icons-07.3b432098.svg";